export default "__VITE_ASSET__BtKFjGTm__"